import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'psUiSearch',
})
export class SearchPipe implements PipeTransform {
  transform(items: any[], searchText: string, fields?: string[]): any[] {
    if (!items) {
      return [];
    }

    if (!searchText) {
      return items;
    }

    searchText = searchText.toLowerCase();

    let filteredItems: any[];

    if (fields && fields.length > 0) {
      filteredItems = items.filter((item) => {
        return fields
          .map((key) =>
            item[key]?.toString().toLowerCase().includes(searchText.toString())
          )
          .some((value) => !!value);
      });
    } else {
      filteredItems = items.filter((item) => {
        return item.toLowerCase().includes(searchText);
      });
    }

    return filteredItems;
  }
}
